import * as React from 'react';

const SvgDownChevron = (props) => /* @__PURE__ */ React.createElement("svg", { "data-fabric-icon-v2": "navigational-24", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 10L11.3598 14.4665C11.7307 14.7756 12.2693 14.7756 12.6402 14.4665L18 10", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));

export { SvgDownChevron as default };
//# sourceMappingURL=down-chevron.svg.js.map
